// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2_HK1","buttons":"Footer_buttons__3P9GO"};